import Vue from 'vue';

import createPersistedState from 'vuex-persistedstate';
import ElementUI from 'element-ui';
// import Fragment from 'vue-fragment';
import locale from 'element-ui/lib/locale/lang/ru-RU';
import VModal from 'vue-js-modal';
import vSelect from 'vue-select';
import VueTextareaAutogrowDirective from 'vue-textarea-autogrow-directive';
import VueQuillEditor from 'vue-quill-editor'
import PortalVue from 'portal-vue'
import AvatarCropper from 'vue-avatar-cropper'

import App from './App';
import router from './router';
import store from './store';

import '@/assets/scss/main.scss';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import IconBase from '@/components/icons/IconBase';
import IconAccept from '@/components/icons/IconAccept';
import IconAction from '@/components/icons/IconAction';
import IconArrowDown from '@/components/icons/IconArrowDown';
import IconArrowLeftSecond from '@/components/icons/IconArrowLeftSecond';
import IconArrowRight from '@/components/icons/IconArrowRight';
import IconArrowRightSecond from '@/components/icons/IconArrowRightSecond';
import IconArrowTop from '@/components/icons/IconArrowTop';
import IconBook from '@/components/icons/IconBook';
import IconCancel from '@/components/icons/IconCancel';
import IconCareer from '@/components/icons/IconCareer';
import IconCloud from '@/components/icons/IconCloud';
import IconDelete from '@/components/icons/IconDelete';
import IconDoc from '@/components/icons/IconDoc';
import IconDonut from '@/components/icons/IconDonut';
import IconDoubleArrowRight from '@/components/icons/IconDoubleArrowRight';
import IconDraggable from '@/components/icons/IconDraggable';
import IconEdit from '@/components/icons/IconEdit';
import IconFaq from '@/components/icons/IconFaq';
import IconFilter from '@/components/icons/IconFilter';
import IconInfo from '@/components/icons/IconInfo';
import IconProfile from '@/components/icons/IconProfile';
import IconProgram from '@/components/icons/IconProgram';
import IconSave from '@/components/icons/IconSave';
import IconSearch from '@/components/icons/IconSearch';
import IconSettings from '@/components/icons/IconSettings';
import IconSettingsMain from '@/components/icons/IconSettingsMain';
import IconSuccess from '@/components/icons/IconSuccess';
import IconRemove from '@/components/icons/IconRemove';
import IconVideo from '@/components/icons/IconVideo';
import IconDemanded from '@/components/icons/IconDemanded';
import { httpWithLoader } from '@/http-common';

Vue.component('icon-base', IconBase);
Vue.component('icon-accept', IconAccept);
Vue.component('icon-action', IconAction);
Vue.component('icon-arrow-down', IconArrowDown);
Vue.component('icon-arrow-left-second', IconArrowLeftSecond);
Vue.component('icon-arrow-right', IconArrowRight);
Vue.component('icon-arrow-right-second', IconArrowRightSecond);
Vue.component('icon-arrow-top', IconArrowTop);
Vue.component('icon-book', IconBook);
Vue.component('icon-cancel', IconCancel);
Vue.component('icon-career', IconCareer);
Vue.component('icon-cloud', IconCloud);
Vue.component('icon-delete', IconDelete);
Vue.component('icon-doc', IconDoc);
Vue.component('icon-donut', IconDonut);
Vue.component('icon-double-arrow-right', IconDoubleArrowRight);
Vue.component('icon-draggable', IconDraggable);
Vue.component('icon-edit', IconEdit);
Vue.component('icon-faq', IconFaq);
Vue.component('icon-filter', IconFilter);
Vue.component('icon-info', IconInfo);
Vue.component('icon-profile', IconProfile);
Vue.component('icon-program', IconProgram);
Vue.component('icon-save', IconSave);
Vue.component('icon-search', IconSearch);
Vue.component('icon-settings', IconSettings);
Vue.component('icon-settings-main', IconSettingsMain);
Vue.component('icon-success', IconSuccess);
Vue.component('icon-remove', IconRemove);
Vue.component('icon-video', IconVideo);
Vue.component('icon-demanded', IconDemanded);

Vue.component('v-select', vSelect);

Vue.use(ElementUI, { locale });
// Vue.use(Fragment.Plugin);
Vue.use(VModal);
Vue.use(VueTextareaAutogrowDirective);

Vue.use(VueQuillEditor, {
    modules: {
        clipboard: {
            matchVisual: false
        },
        toolbar: {
            container: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', { 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image', 'video']
            ],
            handlers: {
                image: function() {
                    var range = this.quill.getSelection();
                    var value = prompt('Введите URL адрес изображения');
                    if(value) {
                        this.quill.insertEmbed(range.index, 'image', value);
                    }
                },
                video: function() {
                    var range = this.quill.getSelection();
                    var value = prompt('Введите URL адрес видео');
                    if(value.includes('youtube')) {
                        let resValue = value.split('/')
                        resValue[2] = resValue[3].includes('embed') ? resValue[2] : resValue[2] + '/embed'
                        resValue[3] = resValue[3].includes('watch') ? resValue[3].substring(
                            resValue[3].indexOf("=") + 1, 
                            resValue[3].indexOf("&")
                        ) : resValue[3]
                        resValue = resValue.join('/')
                        this.quill.insertEmbed(range.index, 'video', resValue);
                    } else if(value.includes('youtu.be')) {
                        let resValue = value.split('/')
                        resValue[2] = 'youtube.com/embed'
                        resValue = resValue.join('/')
                        this.quill.insertEmbed(range.index, 'video', resValue);
                    } else if(value.includes('loom')) {
                        let resValue = value.split('/')
                        resValue[3] = 'embed'
                        resValue = resValue.join('/')
                        this.quill.insertEmbed(range.index, 'video', resValue);
                    }
                    else alert("Вставьте видео из loom или youtube");
                }
              },
        }
      },
      placeholder: 'Не заполнено',
      theme: 'snow'
})

Vue.use(PortalVue)
Vue.use(AvatarCropper);

Vue.config.productionTip = false;

httpWithLoader.defaults.showLoader = true;

Vue.directive("click-outside", {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener("click", el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent)
    },
  });

  Vue.directive('scroll', {
    inserted: function (el, binding) {
      let f = function (evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener('scroll', f)
        }
      }
      window.addEventListener('scroll', f)
    }
  })
  
new Vue({
    router,
    store,
    render: (h) => h(App),
    created() {
        httpWithLoader.interceptors.request.use((config) => {
                if (config.showLoader) {
                    store.dispatch('loader/pending');
                }

                return config;
            }, (error) => {
                if (error.config.showLoader) {
                    store.dispatch('loader/done');
                }

                return Promise.reject(error);
            }
        );
        httpWithLoader.interceptors.response.use((response) => {
                if (response.config.showLoader) {
                    store.dispatch('loader/done');
                }

                return response;
            }, (error) => {
                const response = error.response;

                if (response.config.showLoader) {
                    store.dispatch('loader/done');
                }

                return Promise.reject(error);
            }
        )
    }
}).$mount('#app');
